import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-shrink font-bold" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "basis-1/2 flex" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex-col" }
const _hoisted_6 = { class: "flex-grow justify-self-center border-2 border-next-neu px-2" }
const _hoisted_7 = { class: "flex flex-col justify-center" }
const _hoisted_8 = { class: "flex-grow px-2 flex items-center mb-2" }
const _hoisted_9 = { class: "flex-grow px-2 flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["grid grid-cols-1 place-content-between h-52 p-4", _ctx.coloreAttivo])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.nomeProgetto), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex-grow px-2 text-white mb-2", _ctx.coloreStatoClass])
            }, _toDisplayString(_ctx.siglaStato), 3),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.siglaTag), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.statoProgetto), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.tag), 1)
          ])
        ])
      ]),
      _createVNode(_component_NextButton, {
        variant: "outline-secondary",
        class: "basis-1/4 self-end px-3 py-1 ml-3"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Vedi")
        ])),
        _: 1
      })
    ])
  ], 2))
}